import * as React from 'react'
import { NavLink } from 'react-router-dom'

import Menu from '@mui/material/Menu'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'

import { Box } from '@mui/system'

import { Drawer, IconButton, Typography } from '@mui/material'
import BallotIcon from '@mui/icons-material/Ballot'
import StepperSeeDetailsSuscriber from '../Modals/RightModals/SeeDetailsSuscriber'
import StepperAddUserSuscriber from '../Modals/RightModals/AddUserforSuscriber'
import useStylesModalMenuSuscriberOfOrganization from './useStyleModalMenuSuscriberOfOrganization'
// import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import { useState } from 'react'

export default function ModalMenuSuscribersofOrganization ({
  id,
  item,
  setLoading
}) {
  const classes = useStylesModalMenuSuscriberOfOrganization()
  const [anchorEl, setAnchorEl] = useState(null)
  const [stateUserOrganization, setStateUserOrganization] = useState(false)
  const [stateDetailsSuscriber, setstateDetailsSuscriber] = useState(false)

  const open = Boolean(anchorEl)

  const handleClickIcon = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const list = (anchor) => (
    <Box className={classes.stepperStyle} role="presentation">
      <StepperAddUserSuscriber
        style={{ marginTop: '5%' }}
        setStateUserOrganization={setStateUserOrganization}
        item={item}
        setLoading={setLoading}
      />
    </Box>
  )

  const detailsSuscriber = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <StepperSeeDetailsSuscriber
        style={{ marginTop: '5%' }}
        setstateDetailsSuscriber={setstateDetailsSuscriber}
        item={item}
        setLoading={setLoading}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickIcon}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          id={id}
          item={item}
          setLoading={setLoading}
          onClose={handleClose}
          setStateUserOrganization={setStateUserOrganization}
          setstateDetailsSuscriber={setstateDetailsSuscriber}
        />
      </Menu>
      <Drawer anchor={'right'} open={stateUserOrganization}>
        {list('right')}
      </Drawer>
      <Drawer anchor={'right'} open={stateDetailsSuscriber}>
        {detailsSuscriber('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({
  id,
  item,
  setLoading,
  onClose,
  setStateUserOrganization,
  setstateDetailsSuscriber
}) {
  const classes = useStylesModalMenuSuscriberOfOrganization()
  return (
    <Box
      sx={{
        width: 250,
        height: 150,
        display: 'flex',
        flexDirection: 'column'
      }}
      className={classes.boxStyle}
    >
      <IconButton
        onClick={() => {
          setstateDetailsSuscriber(true)
          onClose()
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>

      {/* {isOrgTesting && userIsAdministrator() && (
        <IconButton
          onClick={() => {
            setStateUserOrganization(true)
            onClose()
          }}
        >
          <Box className={classes.boxTypography}>
            <PersonAddOutlinedIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>
              Añadir usuario
            </Typography>
          </Box>
        </IconButton>
      )} */}

      <NavLink
        to={`/subscribers/${item.subscriber_id}/suscriptions`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
        >
          <Box className={classes.boxTypography}>
            <BallotIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>
              Ver suscripciones y productos
            </Typography>
          </Box>
        </IconButton>
      </NavLink>

      <NavLink
        to={`/subscribers/${item.subscriber_ref_id}/users`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
        >
          <Box className={classes.boxTypography}>
            <PersonOutlineIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>
              Ver usuarios
            </Typography>
          </Box>
        </IconButton>
      </NavLink>
    </Box>
  )
}
